'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by lyj on 2016/9/17.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SingleAuthInfo = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SingleAuthInfo, _Component);

  function SingleAuthInfo() {
    (0, _classCallCheck3.default)(this, SingleAuthInfo);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(SingleAuthInfo).apply(this, arguments));
  }

  (0, _createClass3.default)(SingleAuthInfo, [{
    key: 'removeSelf',
    value: function removeSelf(info) {
      var onRemoveItem = this.props.onRemoveItem;

      if (onRemoveItem) {
        onRemoveItem(info);
      }
    }
  }, {
    key: 'editItem',
    value: function editItem(info) {
      var onEditItem = this.props.onEditItem;

      if (onEditItem) {
        onEditItem(info);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./SingleAuthInfo.scss');
      var _props = this.props;
      var info = _props.info;
      var index = _props.index;

      var currentClassName = '';
      if (index % 2 === 1) {
        currentClassName = styles.gray;
      }
      return _react2.default.createElement(
        'tr',
        { className: currentClassName },
        _react2.default.createElement(
          'td',
          { className: styles.item },
          _react2.default.createElement('img', (0, _defineProperty3.default)({ className: styles.radio,
            src: 'http://tupian.goeasy.cn:9999/yipinwang/per_center/edit.png',
            alt: '', onClick: function onClick() {
              return _this2.editItem(info);
            } }, 'alt', ''))
        ),
        _react2.default.createElement(
          'td',
          { className: styles.item },
          info.personalName
        ),
        _react2.default.createElement(
          'td',
          { className: styles.item },
          info.personalMobile
        ),
        _react2.default.createElement(
          'td',
          { className: styles.item },
          info.isDefault === '1' ? '是' : ''
        ),
        _react2.default.createElement(
          'td',
          { className: styles.item },
          _react2.default.createElement('img', { className: styles.radio, onClick: function onClick() {
              return _this2.removeSelf(info);
            },
            src: 'http://tupian.goeasy.cn:9999/yipinwang/per_center/delete.png',
            alt: '' })
        )
      );
    }
  }]);
  return SingleAuthInfo;
}(_react.Component), _class.propTypes = {
  index: _react.PropTypes.number,
  info: _react.PropTypes.object,
  onEditItem: _react.PropTypes.func,
  onRemoveItem: _react.PropTypes.func
}, _temp);
exports.default = SingleAuthInfo;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SingleAuthInfo/SingleAuthInfo.js
 ** module id = 1428
 ** module chunks = 0
 **/